import React, { useEffect, useState } from "react";
import axios from "../../api/axios";

// MUI components
import {
  Grid,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  TablePagination,
  Paper,
  IconButton,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Typography,
} from "@mui/material";
import Icon from "@mui/material/Icon";

// Custom components
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

function Grades() {
  const [Grades, setGrades] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentItem, setCurrentItem] = useState({ id: null, name: "" });
  const [snackbar, setSnackbar] = useState({ open: false, message: "" });

  // Pagination states
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const fetchGrades = async () => {
    try {
      const response = await axios.get("/grade-levels");
      setGrades(response.data);
    } catch (err) {
      console.error("Failed to fetch Grade Levels", err);
    }
  };

  useEffect(() => {
    fetchGrades();
  }, []);

  const handleSave = async () => {
    try {
      if (currentItem.id) {
        await axios.put(`/grade-levels/${currentItem.id}`, { name: currentItem.name });
        setSnackbar({ open: true, message: "Grade Level updated successfully" });
      } else {
        await axios.post("/grade-levels", { name: currentItem.name });
        setSnackbar({ open: true, message: "Grade Level added successfully" });
      }
      fetchGrades();
      setOpenDialog(false);
      setCurrentItem({ id: null, name: "" });
    } catch (err) {
      console.error(err);
      alert("Something went wrong.");
    }
  };

  const handleEdit = (item) => {
    setCurrentItem(item);
    setOpenDialog(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this Grade Level?")) {
      try {
        await axios.delete(`/grade-levels/${id}`);
        fetchGrades();
        setSnackbar({ open: true, message: "Grade Level deleted successfully" });
      } catch (err) {
        console.error("Delete failed", err);
      }
    }
  };

  // Pagination Handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Slice data for current page
  const paginatedItems = Grades.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox py={3}>
        <Grid container justifyContent="space-between" alignItems="center" px={2} mb={2}>
          <Typography variant="h5">Grade Level</Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpenDialog(true)}
            sx={{ color: "#fff" }} // white text color
          >
            Add New
          </Button>
        </Grid>

        <TableContainer component={Paper} elevation={3} sx={{ borderRadius: 3 }}>
          <Table>
            {/* <TableHead>
              <TableRow sx={{ backgroundColor: "#f0f2f5" }}>
                <TableCell sx={{ fontWeight: "bold" }}>#</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Item Name</TableCell>
                <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>Actions</TableCell>
              </TableRow>
            </TableHead> */}

            <TableBody>
              {paginatedItems.length > 0 ? (
                paginatedItems.map((item, index) => (
                  <TableRow
                    key={item.id}
                    hover
                    sx={{ "&:last-child td, &:last-child th": { borderBottom: 0 } }}
                  >
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                    <TableCell>{item.name}</TableCell>
                    <TableCell sx={{ textAlign: "center" }}>
                      <IconButton color="primary" onClick={() => handleEdit(item)}>
                        <Icon>edit</Icon>
                      </IconButton>
                      <IconButton color="error" onClick={() => handleDelete(item.id)}>
                        <Icon>delete</Icon>
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center" sx={{ padding: 3 }}>
                    No Grade Level found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          <TablePagination
            component="div"
            count={Grades.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </TableContainer>
      </MDBox>

      {/* Add/Edit Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth>
        <DialogTitle>{currentItem.id ? "Edit Grade" : "Add New Grade"}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            label="Grade Level Name"
            fullWidth
            margin="normal"
            value={currentItem.name}
            onChange={(e) => setCurrentItem({ ...currentItem, name: e.target.value })}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button onClick={handleSave} variant="contained" color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ open: false, message: "" })}
        message={snackbar.message}
      />

      <Footer />
    </DashboardLayout>
  );
}

export default Grades;
